var API_DOMAIN  = "https://alagarcrackers.zentexus.com/api";

export default API_DOMAIN